module.exports = __webpack_public_path__ + "img/sound.b5b84a37.svg";